import React, { createContext, useContext, useState, useEffect } from 'react';
import { publicAPI } from '../services/api';

const SiteDataContext = createContext(null);

export const useSiteData = () => {
  const context = useContext(SiteDataContext);
  if (!context) throw new Error('useSiteData must be used within SiteDataProvider');
  return context;
};

// Fallback mock data for when API isn't available
const fallbackSettings = {
  siteName: "TerraHydro Soluções Hidráulicas",
  siteSlogan: "A peça certa, na aplicação correta.",
  whatsapp: "5562991953619",
  phone: "556233001656",
  email: "contato@terrahydro.com.br",
  address: { street: "Av. Industrial, 1234", city: "Goiânia", state: "GO", zipcode: "74000-000" },
  social: { instagram: "@terrahydro", facebook: "terrahydrosolucoes", linkedin: "company/terrahydro" },
  businessHours: { monday_friday: "8h - 18h", saturday: "8h - 12h", sunday: "Fechado" },
  logoUrl: "https://customer-assets.emergentagent.com/job_hydro-specialist/artifacts/1se2hklr_Verde%20e%20Branco%20Startup%20de%20Soluc%CC%A7o%CC%83es%20Agrono%CC%82micas%20Moderno%20Carta%CC%83o%20de%20Visita%20-%201.jpeg"
};

export const SiteDataProvider = ({ children }) => {
  const [settings, setSettings] = useState(fallbackSettings);
  const [categories, setCategories] = useState([]);
  const [pageContents, setPageContents] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadSiteData();
  }, []);

  const loadSiteData = async () => {
    try {
      const [settingsData, categoriesData] = await Promise.all([
        publicAPI.getSettings().catch(() => null),
        publicAPI.getCategories().catch(() => [])
      ]);
      if (settingsData && Object.keys(settingsData).length > 0) setSettings(settingsData);
      if (categoriesData.length > 0) setCategories(categoriesData);

      // Load page contents
      const pageKeys = ['hero', 'how_it_works', 'differentials', 'testimonials', 'cta', 'about_company', 'featured_products', 'footer'];
      const contents = {};
      await Promise.all(
        pageKeys.map(async (key) => {
          try {
            const data = await publicAPI.getPageContent(key);
            if (data && Object.keys(data).length > 0) contents[key] = data;
          } catch (e) { /* skip */ }
        })
      );
      setPageContents(contents);
    } catch (e) {
      console.error('Error loading site data:', e);
    } finally {
      setLoaded(true);
    }
  };

  return (
    <SiteDataContext.Provider value={{ settings, categories, pageContents, loaded }}>
      {children}
    </SiteDataContext.Provider>
  );
};
